import { useMutation } from '@tanstack/react-query';
import api from '../../../services/api';
import { OptionalProductDataFilter } from '../findAll';

interface Params {
    page: number;
    perPage: number;
    'filters[categories][]': Array<number>;
    'filters[stores][]': Array<number>;
    'filters[product]': string;
    'filters[barCode]': string;
    optionalDataFilter: OptionalProductDataFilter;
}

export const KEY_EXPORT_PLANOGRAM = 'KEY_EXPORT_PLANOGRAM';

export interface Planogram {
    id: number;
    planogram_code: string;
    status: string;
    standard_amount: number;
    alert_level: number;
    price_list_in_cents: number;
    price_final_in_cents: number;
    stock_amount: number;
    created_at: string;
    updated_at: string;
    due_date: any;
    product_id: number;
    store_id: number;
    store: Store;
    product: Product;
    sales_in_seven_days: number;
    stock_turnover_seven_days: number;
    expected_gross_margin: number | null;
    expected_price_in_cents: number | null;
    expected_store_stock: number;
    actual_gross_margin: any;
    actual_store_stock: any;
    daily_stock_turnover: number;
    calculated_standard_stock: number;
    calculated_price_in_cents: any;
}

export interface Store {
    name: string;
    id: number;
}

export interface Product {
    id: number;
    name: string;
    image_url: string;
    category_id: number;
    imported_expected_from_category: any;
    expected_gross_margin: any;
    expected_store_stock: any;
    last_price_in_cents: number;
    Category: Category;
    BarCodes: any[];
}

export interface Category {
    expected_gross_margin: any;
    expected_store_stock: any;
    id: number;
}

const exportPlanograms = async (data: Params) => {
    const response = await api.get<Planogram[]>(`/product/planograms/export`, {
        params: {
            ...data,
        },
    });
    return response.data;
};

export const useExportPlanograms = (params: Params) => {
    return useMutation({
        mutationFn: () => exportPlanograms(params),
    });
};
